import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectAll", "userCheckbox", "batchSubmit", "operationSelect", "roleSelectContainer", "selectedUserIds"]

  connect() {
    this.updateBatchOperations()
  }

  selectAllChanged() {
    const isChecked = this.selectAllTarget.checked
    this.userCheckboxTargets.forEach(checkbox => {
      checkbox.checked = isChecked
    })
    this.updateBatchOperations()
  }

  checkboxChanged() {
    this.updateBatchOperations()
  }

  operationChanged() {
    if (this.operationSelectTarget.value === 'change_role') {
      this.roleSelectContainerTarget.classList.remove('js-hidden')
      this.roleSelectContainerTarget.classList.add('js-visible')
    } else {
      this.roleSelectContainerTarget.classList.remove('js-visible')
      this.roleSelectContainerTarget.classList.add('js-hidden')
    }
    this.updateBatchOperations()
  }

  updateBatchOperations() {
    const checkedBoxes = this.userCheckboxTargets.filter(cb => cb.checked)
    const selectedIds = checkedBoxes.map(cb => cb.value)
    
    this.batchSubmitTarget.disabled = checkedBoxes.length === 0 || !this.operationSelectTarget.value
    this.selectedUserIdsTarget.value = selectedIds.join(',')
  }

  changeRole(event) {
    const userId = event.currentTarget.dataset.userId
    const newRole = event.currentTarget.value

    if (!newRole || newRole === '') {
      event.currentTarget.selectedIndex = 0
      return
    }

    if (confirm(`Are you sure you want to change this user's role to ${newRole}?`)) {
      this.submitRoleChange(userId, newRole)
    } else {
      event.currentTarget.selectedIndex = 0
    }
  }

  submitRoleChange(userId, newRole) {
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = `/admin/users/${userId}/role`

    // Add CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    const csrfInput = document.createElement('input')
    csrfInput.type = 'hidden'
    csrfInput.name = 'authenticity_token'
    csrfInput.value = csrfToken
    form.appendChild(csrfInput)

    // Add method override for PATCH
    const methodInput = document.createElement('input')
    methodInput.type = 'hidden'
    methodInput.name = '_method'
    methodInput.value = 'PATCH'
    form.appendChild(methodInput)

    // Add role type
    const roleInput = document.createElement('input')
    roleInput.type = 'hidden'
    roleInput.name = 'role_type'
    roleInput.value = newRole
    form.appendChild(roleInput)

    document.body.appendChild(form)
    form.submit()
  }
}
